import { RefObject } from "react";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import { FieldValues, UseFormRegister } from "react-hook-form";
import { IEftba002, IEftba004 } from "src/pages/Profile/interface";

export interface IRefUsersModals{
    actionButtonInvite: (businessGroupId?: number) => void;
    actionButtonRegister: (businessGroupId: number) => void;
    actionButtonDelete: (id: number, name: string) => void;
    actionButtonDisable: (id: number, name: string) => void;
    actionButtonRestore: (id: number, name: string) => void;
    actionButtonMaintenance: (id: number, subtitleModal: string) => void;
}

export interface IComponentUsersModals{
    paginationRef: RefObject<IForwardPagination>;
    paginationInvitationRef?: RefObject<IForwardPagination>;
}

export interface IUserMaintenance{
    eftba004: IEftba004[];
    eftba002: IEftba002[];
    schedule: string[][];
    validateIp: boolean;
}

export interface IRestrictions{
    refSchedule: any;
    data: Omit<IUserMaintenance, "eftba004" | "eftba002">;
    register: UseFormRegister<FieldValues>;
}
  
export const defaultStateSchedule = [
	["Semana Inteira","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"],
	["Domingo","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"],
	["Segunda","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"],
	["Terça","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"],
	["Quarta","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"],
	["Quinta","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"],
	["Sexta","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"],
	["Sábado","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false","false"]
];
